import Color from 'color';
import styled, { keyframes } from 'styled-components';
import { redColor, cashColor } from 'pages/Logs/components/LogTable.styled';
import { orange, lFColor, lFColor0 } from 'pages/components/LFHeader/LFHeader.styled';
import { topBarColor } from 'pages/styles';

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 420px;
  padding: 24px 22px 20px;
  box-sizing: border-box;
  font-family: inherit;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 14px;
  animation: ${fadeUp} 220ms ease;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee8f6;
`;

export const HeaderIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 14px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background: linear-gradient(145deg, ${lFColor0} 0%, ${lFColor} 100%);
  box-shadow: 0 8px 18px ${Color(lFColor0).alpha(0.28).toString()};
  svg {
    font-size: 26px !important;
  }
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  padding-top: 2px;
`;

export const MainLabel = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #212529;
  letter-spacing: -0.02em;
`;

export const HeaderSub = styled.div`
  font-size: 13px;
  color: #6c757d;
  line-height: 1.45;
`;

export const Summary = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  padding: 14px 16px;
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    ${Color(lFColor0).alpha(0.08).toString()} 0%,
    ${Color(lFColor).alpha(0.04).toString()} 100%
  );
  border: 1px solid ${Color(lFColor0).alpha(0.14).toString()};
`;

export const SummaryLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const RoomName = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #212529;
  letter-spacing: -0.02em;
  line-height: 1.2;
`;

export const BookerLine = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${Color(lFColor).darken(0.05).toString()};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SummaryRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
`;

export const TotalLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #868e96;
`;

export const TotalAmount = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: ${lFColor};
  letter-spacing: -0.02em;
  line-height: 1.15;
`;

export const ChargesColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ChargesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const ChargeCard = styled.div`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #eceff3;
  background: #fbfcfd;
  border-radius: 12px;
  padding: 14px;
  transition: border-color 160ms ease, background 160ms ease;
  &:focus-within {
    border-color: ${Color(lFColor0).alpha(0.35).toString()};
    background: white;
  }
`;

export const ChargeTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

export const ChargeInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1;
`;

export const ChargeDescription = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #212529;
  line-height: 1.35;
`;

export const ChargeMeta = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 10px;
  font-size: 12px;
  font-weight: 500;
  color: #868e96;
`;

export const ChargeBranch = styled.span`
  font-weight: 600;
  color: #6c757d;
`;

export const ChargeAmount = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #343a40;
  flex-shrink: 0;
  white-space: nowrap;
`;

export const AdjustBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AdjustLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #adb5bd;
`;

export const AdjustRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const AmountInput = styled.input<{ isError?: boolean }>`
  flex: 1 1 auto;
  min-width: 0;
  height: 40px;
  border-radius: 8px;
  border: 1.5px solid ${({ isError }) => (isError ? redColor : '#dee2e6')};
  padding: 0 12px;
  font-size: 14px;
  font-weight: 600;
  background: white;
  color: #212529;
  box-sizing: border-box;
  &:focus {
    outline: none;
    border-color: ${orange};
    box-shadow: 0 0 0 0.15rem ${Color(orange).alpha(0.2).toString()};
  }
`;

export const SecondaryBtn = styled.button`
  flex: 0 0 auto;
  height: 40px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1.5px solid ${Color(lFColor).alpha(0.28).toString()};
  background: white;
  color: ${lFColor};
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  box-sizing: border-box;
  white-space: nowrap;
  &:hover:not(:disabled) {
    background: ${Color(lFColor).alpha(0.06).toString()};
  }
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const ActionsRow = styled.div`
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid #eee8f6;
  display: flex;
  gap: 10px;
  width: 100%;
`;

export const PayAllBtn = styled.button`
  flex: 1.4 1 0;
  min-width: 0;
  height: 44px;
  border: none;
  border-radius: 10px;
  background: ${cashColor};
  color: white;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  &:hover:not(:disabled) {
    background: ${Color(cashColor).darken(0.08).toString()};
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const DeleteAllBtn = styled.button`
  flex: 1 1 0;
  min-width: 0;
  height: 44px;
  border: 1.5px solid ${Color(redColor).alpha(0.3).toString()};
  border-radius: 10px;
  background: white;
  color: ${redColor};
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  box-sizing: border-box;
  &:hover:not(:disabled) {
    background: ${Color(redColor).alpha(0.08).toString()};
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.div`
  margin-top: 2px;
  font-size: 11px;
  color: ${redColor};
`;

export const ConfirmContainer = styled.div`
  width: min(92vw, 400px);
  padding: 20px;
  background: white;
  border-radius: 14px;
  font-family: inherit;
  box-sizing: border-box;
`;

export const ConfirmTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 8px;
`;

export const ConfirmRoom = styled.div`
  background: ${Color(topBarColor).lighten(0.55).toString()};
  color: ${Color(topBarColor).darken(0.55).toString()};
  width: calc(100% + 40px);
  margin-left: -20px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 14px;
`;

export const ConfirmMessage = styled.div`
  font-size: 14px;
  color: #525252;
  line-height: 1.5;
`;

export const ConfirmDetail = styled.div`
  margin-top: 12px;
  padding: 12px;
  border-radius: 6px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  font-size: 13px;
  color: #343a40;
  font-weight: 600;
`;

export const ConfirmActions = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export const ConfirmCancel = styled.button`
  height: 40px;
  padding: 0 16px;
  border-radius: 6px;
  border: 1.5px solid #ced4da;
  background: white;
  color: #495057;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  &:hover {
    background: #f8f9fa;
  }
`;

export const ConfirmOk = styled.button<{ isDanger?: boolean, isCash?: boolean }>`
  height: 40px;
  padding: 0 16px;
  border-radius: 6px;
  border: none;
  background: ${({ isDanger, isCash }) => (
    isDanger ? redColor : isCash ? cashColor : lFColor
  )};
  color: white;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 88px;
  &:hover {
    background: ${({ isDanger, isCash }) => (
    isDanger
      ? Color(redColor).darken(0.08).toString()
      : isCash
        ? Color(cashColor).darken(0.08).toString()
        : Color(lFColor).darken(0.1).toString()
  )};
  }
  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;
